import * as actionTypes from "../actionTypes";
import axios from "../../../services/axios";
import {setMessage} from "../message";

const loadDormitoryQueueApplicationRequest = () => {
    return {
        type: actionTypes.LOAD_DORMITORY_QUEUE_APPLICATION_REQUEST,
    };
};

export const loadDormitoryQueueApplicationSuccess = (payload) => {
    return {
        type: actionTypes.LOAD_DORMITORY_QUEUE_APPLICATION_SUCCESS,
        payload: payload,
    };
};

const loadDormitoryQueueApplicationFailure = (error) => {
    return {
        type: actionTypes.LOAD_DORMITORY_QUEUE_APPLICATION_FAILURE,
        error: error,
    };
};

const createDormitoryApplicationRequest = () => {
    return {
        type: actionTypes.CREATE_DORMITORY_APPLICATION_REQUEST,
    };
};

const createDormitoryApplicationSuccess = (payload) => {
    return {
        type: actionTypes.CREATE_DORMITORY_APPLICATION_SUCCESS,
        payload: payload,
    };
};

const createDormitoryApplicationFailure = (error) => {
    return {
        type: actionTypes.CREATE_DORMITORY_APPLICATION_FAILURE,
        error: error,
    };
};

const loadPremiumPenaltyRequest = () => {
    return {
        type: actionTypes.LOAD_PREMIUM_PENALTY_REQUEST,
    };
};

const loadPremiumPenaltySuccess = (payload) => {
    return {
        type: actionTypes.LOAD_PREMIUM_PENALTY_SUCCESS,
        payload: payload,
    };
};

const loadPremiumPenaltyFailure = (error) => {
    return {
        type: actionTypes.LOAD_PREMIUM_PENALTY_FAILURE,
        error: error,
    };
};

const loadPrivilegesRequest = () => {
    return {
        type: actionTypes.LOAD_PRIVILEGES_REQUEST,
    };
};

const loadPrivilegesSuccess = (payload) => {
    return {
        type: actionTypes.LOAD_PRIVILEGES_SUCCESS,
        payload: payload,
    };
};

const loadPrivilegesFailure = (error) => {
    return {
        type: actionTypes.LOAD_PRIVILEGES_FAILURE,
        error: error,
    };
};

export const setApplicationDownload = (targetDownload) => {
    return {
        type: actionTypes.SET_APPLICATION_DOWNLOAD,
        targetDownload: targetDownload
    }
}

export const loadApplicationReport = () => {
    return {
        type: actionTypes.LOAD_APPLICATION_REPORT
    }
}

export const onLoadApplicationReportStopped = () => {
    return {
        type: actionTypes.SAVE_APPLICATION_REPORT
    }
}

export const loadDormitoryQueueApplication = () => {
    return (dispatch) => {
        dispatch(loadDormitoryQueueApplicationRequest());
        axios
            .get(`/api/v1/dormitory-queue-application`)
            .then((response) => {
                response.data.sort((a, b) => b.id - a.id);
                dispatch(loadDormitoryQueueApplicationSuccess(response.data));
            })
            .catch((error) => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
                dispatch(loadDormitoryQueueApplicationFailure(error));
            });
    };
};

export const createDormitoryApplication = () => {
    return (dispatch) => {
        dispatch(createDormitoryApplicationRequest());
        axios
            .post(`/api/v1/dormitory-queue-application/create`)
            .then((response) => {
                dispatch(setMessage({type: 'success', text: "Заявка успешно подана."}))
                dispatch(createDormitoryApplicationSuccess(response.data));
                dispatch(loadDormitoryQueueApplication());
            })
            .catch((error) => {
                dispatch(setMessage({type: 'error', text: "Не удалось подать заявку."}))
                dispatch(createDormitoryApplicationFailure(error));
            });
    };
};

export const loadPremiumPenalty = () => {
    return (dispatch) => {
        dispatch(loadPremiumPenaltyRequest());
        axios
            .get(`/api/v1/dormitory-queue-application/premium-penalty`)
            .then((response) => {
                dispatch(loadPremiumPenaltySuccess(response.data));
            })
            .catch((error) => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
                dispatch(loadPremiumPenaltyFailure(error));
            });
    };
};

export const loadPrivileges = () => {
    return (dispatch) => {
        dispatch(loadPrivilegesRequest());
        axios
            .get(`/api/v1/dormitory-queue-application/privileges`)
            .then((response) => {
                dispatch(loadPrivilegesSuccess(response.data));
            })
            .catch((error) => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
                dispatch(loadPrivilegesFailure(error));
            });
    };
};

export const downloadApplicationExcel = (dormitoryQueueId) => {
    return (dispatch) => {
        dispatch(loadApplicationReport())
        axios.get(`/api/v1/dormitory-queue-application/download-excel-by-application-id?dormitory-queue-id=${dormitoryQueueId}`,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
            }
        ).then(response => {
            dispatch(saveApplicationReport(response))
        }).catch(error => {
            dispatch(setMessage({type: 'error', text: "Не удалось скачать заявление."}))
            dispatch(onLoadApplicationReportStopped())
        });
    }
}

export const saveApplicationReport = (response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    let filename = response.headers['file-name'];
    if (!filename || filename.length === 0) {
        filename = 'Заявление.xlsx';
    } else {
        filename = decodeURI(filename);
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    return onLoadApplicationReportStopped();
}
